/**
 * Componente: FormFieldGroup
 * Agrupador de campos com label e error
 */

import React, { ReactNode } from 'react';

interface FormFieldGroupProps {
  label: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
  helpText?: string;
  className?: string;
}

export const FormFieldGroup: React.FC<FormFieldGroupProps> = ({
  label,
  required = false,
  error,
  children,
  helpText,
  className = '',
}) => {
  return (
    <div className={`form-field-group ${error ? 'has-error' : ''} ${className}`}>
      <label className="field-label">
        {label}
        {required && <span className="required-indicator">*</span>}
      </label>
      <div className="field-input-wrapper">{children}</div>
      {error && <span className="field-error">{error}</span>}
      {helpText && <span className="field-help-text">{helpText}</span>}
    </div>
  );
};

export default FormFieldGroup;
